<div fxLayout="column" fxLayoutAlign="center center" class="h-100-vh">

  <h1>Not found!</h1>

  <a [routerLink]="['/reserved']">Go to dashboard</a>

</div>